import { locale as usLocale } from './en-US';
import { en as vuetifyLocale } from 'vuetify/src/locale';
import { LocaleDefinition } from '@/locales/locale-definition';

export const locale: LocaleDefinition = {
    crmCountry: 'nz',
    fcLocale: 'en-nz',
    label: 'New Zealand',
    firstDayOfWeek: 1,
    distanceUnit: 'km',
    phoneRegion: 'NZ',
    dateFormat: 'dd/MM/yyyy',
    yearFirstDateFormat: 'yyyy-MM-dd',
    shortDateYearFormat: 'dd/MM/yy',
    shortDateFormat: 'dd/MM',
    timeFormat: 'hh:mm a',
    shortTimeFormat: 'hh:mm',
    militaryTimeFormat: 'HH:mm',
    numberFormats: {
        currency: {
            style: 'currency', currency: 'NZD'
        },
        currencyWhole: {
            style: 'currency',
            currency: 'NZD',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        }
    },
    messages: {
        $vuetify: {
            ...vuetifyLocale
        },
        ...usLocale.messages,
        center: 'centre',
        enroll: 'enrol',
        enrollment: 'enrolment',
        hello: 'g\'day, {user}',
        welcome: 'Welcome to ChildcareCRM - {level}',
        dashboardRevenueBold: 'Total Estimated Lifetime Value',
        dashboardRevenue: ' of Families not yet Enrolled/Waitlisted',
        regionLabel: 'Region',
        regionLabelAbv: 'Reg',
        postcodeLabel: 'Postcode',
        corporate: 'Corporate',
        dashboard: 'Dashboard',
        supportEmail: 'support@golineleader.com.au',
        helpPhone: 'Call <a href="tel:+61-02-8039-8276,2">+61 2 8039 8276 ext 2</a>',
        insight: 'Insight'
    }
};
